<template>
    <div class="lms__superadmin_customer_service_show_table">
        <div class="container">
            <div class="columns custom--overflow">
                <div class="column">
                    <template v-if="subscriptions.length || addSubscription">
                    <table>
                        <list-table-head
                            :labels="tableLabels"
                        />
                        <tbody>
                        <template
                            v-for="(subscription, index) in subscriptions"
                        >
                            <lms-superadmin-customer-service-show-table-item
                                :subscription="subscription"
                                :key="index"
                                @emit-cancel="openNotifyCancelSubscription"
                            />
                        </template>
                        <template v-if="addSubscription">
                            <lms-superadmin-customer-service-show-table-item
                                :add-subscription="true"
                                :subscriptions-dates="filteredSubscriptionsNotCancelled"
                                @emit-create="openNotifyCreateSubscription"
                                @emit-stop-adding="setAddSubscription(false)"
                            />
                        </template>
                        </tbody>
                    </table>
                    </template>
                    <template v-else>
                        <component-empty-state
                            :item="$t('lms.customer.emptyState.itemSubscription')"
                            :title="'There are no subscriptions for this service.'"
                            :submit-button-active="false"
                        />
                    </template>
                </div>
            </div>
        </div>
        <pop-notify
            :class="'pop__notify--cancel'"
            ref="notifycancelsubscription"
            :title-text="$t(`lms.customer.notify.titleCancelSubscription`)"
            :content-text="$t(`lms.customer.notify.contentAreYouSureCancel`)"
            :cancel-button-text="$t(`lms.customer.notify.dismiss`)"
            :submit-button-text="$t(`lms.customer.notify.submitButton`)"
            :submit-button-danger="true"
            :prevent-close="true"
            :submit-button-animate-loading="true"
            :submit-button-animate-loading-name="'cancel-subscription'"
            @emit-submit="cancelSubscription"
        />
        <pop-notify
            :class="'pop__notify--cancel'"
            ref="notifycreatesubscription"
            :title-text="$t(`lms.customer.notify.createSubscription`)"
            :content-text="$t(`lms.customer.notify.contentAreYouSureCreate`)"
            :cancel-button-text="$t(`lms.customer.notify.cancelButton`)"
            :submit-button-text="$t(`lms.customer.notify.create`)"
            :prevent-close="true"
            :submit-button-animate-loading="true"
            :submit-button-animate-loading-name="'create-subscription'"
            @emit-submit="createSubscription"
        />
    </div>
</template>

<script>
import ListTableHead from '@/components/default/shared/ListTableHead'
import LmsSuperadminCustomerServiceShowTableItem from '@/components/lms/superadmin/customer/service/show/LmsSuperadminCustomerServiceShowTableItem'
import PopNotify from '@/components/default/shared/PopNotify'
import ComponentEmptyState from '@/components/default/shared/ComponentEmptyState'

export default {
  name: 'lms-superadmin-customer-service-show-table',
  components: {
    ComponentEmptyState,
    PopNotify,
    LmsSuperadminCustomerServiceShowTableItem,
    ListTableHead
  },
  data () {
    return {
      addSubscription: false
    }
  },
  props: {
    subscriptions: {
      type: Array
    }
  },
  computed: {
    serviceKey () {
      return this.$route.params.serviceKey
    },
    tableLabels () {
      let labelsArr = []

      if (this.serviceKey === 'SSO') {
        labelsArr.push({
          key: 'name',
          title: 'Name',
          type: 'string'
        })
      }
      labelsArr.push({
        key: 'subscriptionStart',
        title: 'Subscription start',
        type: 'string'
      })
      labelsArr.push({
        key: 'subscriptionEnd',
        title: 'Subscription end',
        type: 'string'
      })
      labelsArr.push({
        key: 'status',
        title: 'Status',
        type: 'string'
      })
      labelsArr.push({
        key: 'createdAt',
        title: 'Created',
        type: 'string'
      })
      labelsArr.push({
        key: 'cancelledAt',
        title: 'Cancelled',
        type: 'string'
      })
      labelsArr.push({
        key: '',
        title: '',
        type: 'string'
      })

      return labelsArr
    },
    filteredSubscriptionsNotCancelled () {
      return this.$store.getters.getLmsSuperadminCustomerSubscriptionsNotCancelledDates(this.serviceKey)
    }
  },
  methods: {
    setAddSubscription (value) {
      this.addSubscription = value
    },
    openNotifyCancelSubscription (data) {
      this.$refs.notifycancelsubscription.setStoreValue(data)
      this.$refs.notifycancelsubscription.openNotify()
    },
    cancelSubscription () {
      const subscriptionID = this.$refs.notifycancelsubscription.storeValue
      this.$store.dispatch('lmsSuperadminCustomerSubscriptionCancel', subscriptionID).finally(() => {
        this.$eventBus.$emit('stop-cancel-subscription')
        this.$eventBus.$emit('get-customer')
        this.$refs.notifycancelsubscription.closeNotify()
      })
    },
    openNotifyCreateSubscription () {
      this.$refs.notifycreatesubscription.openNotify()
    },
    createSubscription () {
      this.$store.dispatch('lmsSuperadminCustomerSubscriptionCreate').then(() => {
        this.setAddSubscription(false)
        this.$eventBus.$emit('get-customer')
      }).finally(() => {
        this.$refs.notifycreatesubscription.closeNotify()
        this.$eventBus.$emit('stop-create-subscription')
      })
    }
  }
}
</script>

<style lang="scss">
    @import "~@/assets/scss/components/lms/superadmin/customers/_lmssuperadmincustomershowservicetable.scss";
</style>
